import { getUnitFromBenchmarkingData } from '@/components/data/Benchmarking/utils/getUnitFromBenchmarkingData'
import { BenchmarkingItemWithUnit, BenchmarkingReportSettings } from '@/hooks'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useColumnHeaderText = (
    data: BenchmarkingItemWithUnit[],
    reportSettings: BenchmarkingReportSettings
) => {
    const { t } = useTranslation('translations')

    const { basis, analysisType } = reportSettings

    const applyWeatherNormalization =
        !['cost', 'emission'].includes(basis) &&
        reportSettings.applyWeatherNormalization
    const applySquareFootage =
        ['facility', 'group'].includes(reportSettings.display) &&
        basis !== 'costPerUsage' &&
        reportSettings.applySquareFootage

    const unit = useMemo(() => {
        const unit = getUnitFromBenchmarkingData(
            data,
            applySquareFootage,
            basis
        )
        return unit ? `(${unit})` : ''
    }, [applySquareFootage, basis, data])

    const normalizationKey = useMemo(() => {
        if (applyWeatherNormalization && applySquareFootage) {
            return 'weather_and_area'
        }

        if (applyWeatherNormalization) {
            return 'weather'
        }

        if (applySquareFootage) {
            return 'area'
        }

        return 'no_norm'
    }, [applySquareFootage, applyWeatherNormalization])

    const label = t(
        `analytics.benchmarking.columnHeaders.otherColumns.${basis}.${analysisType}.${normalizationKey}`
    )

    if (unit) {
        return `${label} ${unit}`
    }

    return label
}
